


















import HeaderNav from '../components/HeaderNav.vue';
export default {
  components: {HeaderNav}
};
